import { useQuery } from '@apollo/client';
import { useAuthInfo } from '@bfa/nextjs-common/contexts';

import {
  GQLGwsEligibilityResponse,
  GQLGwsRequest,
  GQLGwsType,
} from '../../../gql.generated';
import { getGwsResponse } from '../../../utils/gws';
import GET_GWS_ELIGIBILITY_CHECK from '../../queries/GET_GWS_ELIGIBILITY_CHECK';

type EligibilityResponse = GQLGwsEligibilityResponse & {
  loading: boolean;
};

const useGwsEligibilityCheck = (
  gwsType: GQLGwsType,
  request: GQLGwsRequest
): EligibilityResponse => {
  const { isAuthenticated } = useAuthInfo();
  const { data, loading, error } = useQuery(GET_GWS_ELIGIBILITY_CHECK, {
    variables: {
      gwsType,
      userId: request.userId,
      program: request.program,
      productId: request.productId,
    },
    context: {
      teamName: 'Subscriptions - Programs & Upsells',
    },
  });

  return getGwsResponse(
    gwsType,
    data?.me?.checkUserEligibilityForGws,
    request,
    loading,
    error,
    isAuthenticated
  );
};

export { useGwsEligibilityCheck };
